import React from 'react';
import BootstrapImage from 'react-bootstrap/Image';
import { ReactSVG } from 'react-svg';
import PropTypes from 'prop-types';

const Image = (props) => {
    if (props.svg) {
        return <ReactSVG src={require(`../../images/${props.name}`)} {...props} />;
    }
    if (props.name) {
        return <BootstrapImage src={require(`../../images/${props.name}`)} {...props} />;
    }
    return <BootstrapImage {...props} />;
};

Image.propTypes = {
    svg: PropTypes.bool,
    name: PropTypes.string,
};

export default Image;
